import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../api";
import "./Pobotnica.css";

const normalizirajStevilke = (v) =>
    String(v || "").replace(/\D/g, "").slice(0, 10);

const PobotnicaIskanje = () => {
    const [davcnaIskanjePobotnic, nastaviDavcnaIskanjePobotnic] = useState("");
    const [pobotnicaSeznam, nastaviPobotnicaSeznam] = useState([]);
    const [pobotnicaIzbranaId, nastaviPobotnicaIzbranaId] = useState("");
    const [pobotnicaIskanjeNapaka, nastaviPobotnicaIskanjeNapaka] =
        useState("");
    const [pobotnicaIskanjeNalaganje, nastaviPobotnicaIskanjeNalaganje] =
        useState(false);

    const navigate = useNavigate();

    const isciPobotnico = async () => {
        nastaviPobotnicaIskanjeNapaka("");
        nastaviPobotnicaSeznam([]);
        nastaviPobotnicaIzbranaId("");

        const stevke = normalizirajStevilke(davcnaIskanjePobotnic);

        if (!stevke) {
            nastaviPobotnicaIskanjeNapaka(
                "Vpiši davčno ali matično številko upnika."
            );
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            nastaviPobotnicaIskanjeNapaka(
                "Vpiši davčno (8) ali matično (10) številk."
            );
            return;
        }

        nastaviPobotnicaIskanjeNalaganje(true);

        try {
            const params = new URLSearchParams();
            params.set("davcnaAliMaticna", stevke);

            const res = await apiFetch(
                `/api/stran/pobotnica-seznam?${params.toString()}`,
                { method: "GET" }
            );

            if (res.status === 404) {
                nastaviPobotnicaIskanjeNapaka(
                    "Za tega upnika še ni shranjenih pobotnic."
                );
                return;
            }

            if (!res.ok) {
                let msg = "";

                try {
                    const json = await res.json();
                    msg = json?.message || json?.title || "";
                } catch {
                    msg = await res.text().catch(() => "");
                }

                throw new Error(msg || "Napaka pri iskanju pobotnic v bazi.");
            }

            const seznam = await res.json();

            if (!Array.isArray(seznam) || seznam.length === 0) {
                nastaviPobotnicaIskanjeNapaka(
                    "Za tega upnika še ni shranjenih pobotnic."
                );
                return;
            }

            if (seznam.length === 1) {
                const prva = seznam[0];
                const id = prva.id ?? prva.Id;

                if (id == null) {
                    nastaviPobotnicaIskanjeNapaka(
                        "Najdena pobotnica nima ID-ja in je ni mogoče odpreti."
                    );
                    return;
                }

                navigate(`/profil/pobotnica/${id}`);
                return;
            }

            nastaviPobotnicaSeznam(seznam);
        } catch (e) {
            nastaviPobotnicaIskanjeNapaka(
                e?.message || "Napaka pri iskanju pobotnic v bazi."
            );
        } finally {
            nastaviPobotnicaIskanjeNalaganje(false);
        }
    };

    const spremeniIzbranoPobotnico = (e) => {
        const id = e.target.value;
        nastaviPobotnicaIzbranaId(id);

        if (!id) return;

        navigate(`/profil/pobotnica/${id}`);
    };

    return (
        <div className="pf">
            <main className="pobotnica-page">
                <section className="pobotnica-modePicker pobotnica-noPrint">
                    <button
                        type="button"
                        className="pobotnica-modeBtn pobotnica-modeBtn--active"
                        aria-pressed="true"
                    >
                        IŠČI POBOTNICO V BAZI
                    </button>

                    <button
                        type="button"
                        className="pobotnica-modeBtn"
                        onClick={() =>
                            navigate("/profil/pobotnica", {
                                state: {
                                    davcnaAliMaticna: davcnaIskanjePobotnic || "",
                                },
                            })
                        }
                        aria-pressed="false"
                    >
                        KREIRAJ POBOTNICO
                    </button>

                    <button
                        type="button"
                        className="pobotnica-modeBtn"
                        onClick={() => navigate("/profil", { replace: true })}
                    >
                        NAZAJ
                    </button>
                </section>

                <section className="pobotnica-searchBar pobotnica-noPrint">
                    <label className="pobotnica-searchLabel">
                        <span>Davčna ali matična št. upnika</span>

                        <input
                            type="text"
                            value={davcnaIskanjePobotnic}
                            onChange={(e) => {
                                const v = normalizirajStevilke(e.target.value);
                                nastaviDavcnaIskanjePobotnic(v);
                                nastaviPobotnicaIskanjeNapaka("");
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    isciPobotnico();
                                }
                            }}
                            className="pobotnica-input pobotnica-searchInput"
                            inputMode="numeric"
                            placeholder="npr. 12345678 ali 1234567000"
                        />
                    </label>

                    <button
                        type="button"
                        className="pobotnica-inlineBtn"
                        onClick={isciPobotnico}
                        disabled={pobotnicaIskanjeNalaganje}
                    >
                        {pobotnicaIskanjeNalaganje ? "Iščem…" : "Išči pobotnico"}
                    </button>

                    {pobotnicaIskanjeNapaka && (
                        <div className="pobotnica-ajpesError">
                            {pobotnicaIskanjeNapaka}
                        </div>
                    )}

                    {pobotnicaSeznam.length > 1 && (
                        <div className="pobotnica-searchCases">
                            <span className="pobotnica-searchCasesLabel">
                                Najdenih več pobotnic za tega upnika:
                            </span>

                            <select
                                className="pobotnica-searchCasesSelect"
                                value={pobotnicaIzbranaId}
                                onChange={spremeniIzbranoPobotnico}
                            >
                                <option value="">– izberi pobotnico –</option>

                                {pobotnicaSeznam.map((p) => {
                                    const rawId = p.id ?? p.Id;
                                    const idStr =
                                        rawId !== undefined && rawId !== null
                                            ? String(rawId)
                                            : "";

                                    const spis =
                                        p.stevilkaSpisaIzvrsitelja ??
                                        p.StevilkaSpisaIzvrsitelja ??
                                        "";

                                    const opr =
                                        p.opravilnaStevilkaSodisca ??
                                        p.OpravilnaStevilkaSodisca ??
                                        "";

                                    const oznaka = [spis, opr]
                                        .filter(Boolean)
                                        .join(" / ");

                                    const datumRaw =
                                        p.datumPobotnice ??
                                        p.DatumPobotnice ??
                                        p.ustvarjeno ??
                                        p.Ustvarjeno ??
                                        null;

                                    let datumTxt = "";

                                    if (datumRaw) {
                                        const d = new Date(datumRaw);

                                        if (!Number.isNaN(d.getTime())) {
                                            datumTxt = d.toLocaleDateString("sl-SI");
                                        }
                                    }

                                    const upnik = p.upnikNaziv ?? p.UpnikNaziv ?? "";

                                    let label = oznaka || "(brez oznake)";
                                    if (datumTxt) label += ` – ${datumTxt}`;
                                    if (upnik) label += ` – ${upnik}`;

                                    return (
                                        <option
                                            key={idStr || label}
                                            value={idStr}
                                            disabled={!idStr}
                                        >
                                            {label}
                                            {!idStr ? " (ID manjka)" : ""}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    )}
                </section>
            </main>
        </div>
    );
};

export default PobotnicaIskanje;